export enum SectionType {
  SIZE = 'SIZE',
  OPTION = 'OPTION'
}
